module.exports = __webpack_public_path__ + "static/just-kids-c9fd4213dfc7e2e6e854c945d1088557.jpg";